import { render, staticRenderFns } from "./VlastTextIcon.vue?vue&type=template&id=7a18f10c"
import script from "./VlastTextIcon.vue?vue&type=script&lang=js"
export * from "./VlastTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports